import React from 'react';
import {
  CartBtn, TabContent, StoreFooter
} from './ThemeLayoutHelpers';


export default function DarkLayout({ p }) {
  const T = p.storeTheme || {};
  return (
    <div className="min-h-screen flex flex-col bg-gray-950 text-gray-100" style={{ ...p.themeStyles, fontFamily: T.fontFamily || "Sora" }}>
      <nav className="sticky top-0 z-40 bg-black border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <p className="font-bold">{p.storeInfo?.businessName}</p>
          <CartBtn p={p} dark />
        </div>
      </nav>
      <div className="max-w-7xl mx-auto w-full px-4 py-6"><TabContent p={p} dark /></div>
      <StoreFooter p={p} dark />
    </div>
  );
}